import React from "react"
import { Box, Typography } from "@mui/material"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import { keyframes } from "@emotion/react"

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(6px); }
  60% { transform: translateY(3px); }
`

const ScrollIndicator = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        bottom: 16,
        left: "50%",
        transform: "translateX(-50%)",
        textAlign: "center",
        color: "#fff",
        zIndex: 10,
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        animation: `${bounce} 2s infinite`,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        Scroll down
      </Typography>
      <KeyboardArrowDownIcon />
    </Box>
  )
}

export default ScrollIndicator
